const fetchWithTimeout = async (fetchFn, args, timeoutMs = 15000) =>
  Promise.race([
    fetchFn(...args),
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Timeout exceeded')), timeoutMs);
    }),
  ]);

export default fetchWithTimeout;
